import React from 'react';
import RegisterWithInvitation from '../components/RegisterWithInvitation';

const RegisterWithInvitationPage: React.FC = () => {
  return <RegisterWithInvitation />;
};

export default RegisterWithInvitationPage; 